import cacheKeys from '@/data/api/cacheKeys';
import { CATALOG_CACHE_TIME } from '@/data/api/reactQueryConfig';
import { getCfdiUses } from '@/data/api/request/fiscalRequests';
import { useQuery } from '@tanstack/react-query';

export function useGetCfdiUses() {
  const { data, error, isLoading } = useQuery({
    queryFn: getCfdiUses,
    queryKey: [cacheKeys.fiscal.getCFDIUses],
    staleTime: CATALOG_CACHE_TIME,
  });

  return { data, error, isLoading };
}
